// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/si-ha-documentation-list-schema',
  type: 'object',
  required: ['id', 'creatorId'],
  nullable: true,
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    siHaDocumentationStatus: {
      enum: [
        1,
        2,
        3,
        4,
        5,
      ],
    },
    title: {
      type: 'string',
      nullable: true,
    },
    remark: {
      type: 'string',
      nullable: true,
    },
    projectNumber: {
      type: 'string',
      nullable: true,
    },
    clientCompanyName: {
      type: 'string',
      nullable: true,
    },
    clientAddressLine: {
      type: 'string',
      nullable: true,
    },
    clientPostalCode: {
      type: 'string',
      nullable: true,
    },
    clientCity: {
      type: 'string',
      nullable: true,
    },
    clientFirstName: {
      type: 'string',
      nullable: true,
    },
    clientLastName: {
      type: 'string',
      nullable: true,
    },
    clientEMail: {
      type: 'string',
      nullable: true,
    },
    clientPhoneNumber: {
      type: 'string',
      nullable: true,
    },
    addressLine: {
      type: 'string',
      nullable: true,
    },
    city: {
      type: 'string',
      nullable: true,
    },
    postalCode: {
      type: 'string',
      nullable: true,
    },
    nextInspectionDueDate: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
